import type { FC } from "react";
import type { UseFormReturn } from "react-hook-form";
import {
  formValidate,
  getApproveOrRejectOptions,
  PrimaryButton,
  type NewStep2ApprovalForm,
  type Response,
  type ResponsePostCto,
  translate,
} from "@shape/reef-shared";
import { RadioGroupField, TextAreaField } from "components/Form";

interface ApprovalDecisionGateProps {
  approvalButtonText: string;
  approvalForm: UseFormReturn<NewStep2ApprovalForm>;
  approvalFormIsApproved: boolean | null;
  createdStep2: Response<ResponsePostCto>;
  isApprovalRejected: boolean;
  label: string;
  onSubmit: (data: NewStep2ApprovalForm) => void;
  rejectLabel: string;
  submitButtonClassName: string;
  submitDisabled: boolean;
  validateRejectedApprovalComments: (comments?: string) => boolean;
}

export const ApprovalDecisionGate: FC<ApprovalDecisionGateProps> = ({
  approvalButtonText,
  approvalForm,
  approvalFormIsApproved,
  createdStep2,
  isApprovalRejected,
  label,
  onSubmit,
  rejectLabel,
  submitButtonClassName,
  submitDisabled,
  validateRejectedApprovalComments,
}) => (
  <>
    <div className="approval-box">
      <RadioGroupField
        form={approvalForm}
        label={label}
        name="approved"
        options={getApproveOrRejectOptions({
          reject: rejectLabel,
        })}
        layout="horizontal"
        rules={formValidate<NewStep2ApprovalForm, "approved">()}
      />
      {approvalFormIsApproved === false && (
        <TextAreaField
          form={approvalForm}
          label={translate("generic.comments")}
          name="comments"
          rules={{
            required: isApprovalRejected,
            validate: validateRejectedApprovalComments,
          }}
          placeholder={translate("formGeneric.typeHereMandatory")}
        />
      )}
    </div>
    <PrimaryButton
      type="button"
      disabled={approvalFormIsApproved === null || createdStep2.loading || submitDisabled}
      onClick={approvalForm.handleSubmit((data) => onSubmit(data))}
      className={submitButtonClassName}
    >
      {approvalButtonText}
    </PrimaryButton>
  </>
);
